module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjUgMEM0LjcxMDMgMCAwIDQuNzEwMyAwIDEwLjVDMCAxNi4yODk3IDQuNzEwMyAyMSAxMC41IDIxQzE2LjI4OTcgMjEgMjEgMTYuMjg5NyAyMSAxMC41QzIxIDQuNzEwMyAxNi4yODk3IDAgMTAuNSAwWk0xMy45NTc2IDE1LjQ0MjRMOS40NSAxMC45MzQ3VjQuMkgxMS41NVYxMC4wNjUzTDE1LjQ0MjQgMTMuOTU3NkwxMy45NTc2IDE1LjQ0MjRaIiBmaWxsPSIjMDBEMDlDIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/svgs/time.svg
// module id = 1143
// module chunks = 1